import { z } from 'zod';

/**
 * Parses an array of items and removes any item that fail to parse
 *
 * Ej.
 *
 * ```ts
 * const parseNumbers = filterBySchema(z.number());
 * parseNumbers(["a", 1, "c", 3, false]); // [1, 3]
 * ```
 * @returns
 */
export default function filterBySchema<TData>(schema: z.ZodSchema<TData>) {
  return function (items: unknown[]) {
    return items.reduce((parsedItems: TData[], currentItem: unknown) => {
      const parsedItem = schema.safeParse(currentItem);

      if (parsedItem.success) {
        parsedItems.push(parsedItem.data);
      } else {
        console.log('Failed to parse item', currentItem, parsedItem.error);
      }

      return parsedItems;
    }, []);
  };
}
